export const Logo = ({ dark = false, size = 32, mark = false, className = "" }) => (
  <span className={`inline-flex items-center ${className}`} data-testid="brand-logo">
    <img src={mark ? "/logo-mark.png" : dark ? "/logo-mohassib-dark.png" : "/logo-mohassib.png"} alt="Mohassib — محاسب" style={{ height: mark ? size : size * 1.3 }} className="w-auto shrink-0 select-none" draggable={false} />
  </span>
);
